import { CardProps } from "./t-premia-card-types";
import { CardWrapper, CardImage, CardContent, CardTitle, CardDescription, CardHeader } from "./style-component";

const TPremiaCard: React.FC<CardProps> = ({
  children,
  style = {},
  variant = 'default',
  title,
  description,
  imageUrl,
  onClick,
  className,
}) => {
  return (
    <CardWrapper
      style={style}
      $variant={variant}
      onClick={onClick}
      className={className}
    >
      {imageUrl && <CardImage src={imageUrl} alt={title ?? 'Card image'} />}
      <CardContent>
        {(title || description )&& 
        <CardHeader>
          {title && <CardTitle>{title}</CardTitle>}
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>}
        {children}
      </CardContent>
    </CardWrapper>
  );
};

export default TPremiaCard;